export default "__VITE_ASSET__DfZ9amMa__"